import React from "react";

const AchievementTile = () => {
  return (
    <div className="container">
      <div className="achieve-tile flex">
        <div>
          <div className="tile-number">6+</div>
          <div>Projects</div>
        </div>

        <div>
          <div className="tile-number">150+</div>
          <div>Leetcode</div>
        </div>

        <div>
          <div className="tile-number">3+</div>
          <div>Years of experience</div>
        </div>
      </div>
    </div>
  );
};

export default AchievementTile;
